import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { VisibilityOff, RemoveRedEye } from "@mui/icons-material";

const InputPassword: FC<TextFieldProps> = ({ label, ...otherProps }) => {
  const { t: getLabel } = useTranslation();
  const inputLabel = label || getLabel("L_PASSWORD");

  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => setShowPassword(show => !show);

  return (
    <TextField
      fullWidth
      label={inputLabel}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleShowPassword} edge="end">
              {showPassword ? <VisibilityOff /> : <RemoveRedEye />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      name="password"
      autoComplete="password"
      {...otherProps}
    />
  );
};

export default InputPassword;
